module.exports = __webpack_public_path__ + "static/media/Sector7.c75c486a.jpg";